/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Export_Power_Point_Options_Basic_DescriptionInputs */

const en_export_power_point_options_basic_description = /** @type {(inputs: Export_Power_Point_Options_Basic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard export with the most important information`)
};

const de_export_power_point_options_basic_description = /** @type {(inputs: Export_Power_Point_Options_Basic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard Export mit den wichtigsten Informationen`)
};

/**
* | output |
* | --- |
* | "Standard export with the most important information" |
*
* @param {Export_Power_Point_Options_Basic_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const export_power_point_options_basic_description = /** @type {((inputs?: Export_Power_Point_Options_Basic_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Export_Power_Point_Options_Basic_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_export_power_point_options_basic_description(inputs)
	return de_export_power_point_options_basic_description(inputs)
});